import { axiosInstance, handleAxiosResponse } from "../../../core/sources/network";

import { handleError } from "../../app-messages";

export const createNewTicket = ({ ticketInfo }) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.post("/support", {
        supportInfo: ticketInfo,
      });

      const { data } = handleAxiosResponse(response);
      return data;
    } catch (error) {
      handleError(error?.response?.data?.message ?? error.message)(dispatch);
    }
  };
};
